"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OctoChemDB = void 0;
const activeOrNaturalDetails_js_1 = require("./activeOrNaturalDetails.js");
const activesOrNaturals_js_1 = require("./activesOrNaturals.js");
const activesOrNaturalsByMF_js_1 = require("./activesOrNaturalsByMF.js");
const compoundsFromMF_js_1 = require("./compoundsFromMF.js");
const massSpectra_js_1 = require("./massSpectra.js");
const mfsFromEMs_js_1 = require("./mfsFromEMs.js");
const pubmedCompounds_js_1 = require("./pubmedCompounds.js");
const searchInSilicoSpectraByMF_js_1 = require("./searchInSilicoSpectraByMF.js");
const searchInSilicoSpectraByMasses_js_1 = require("./searchInSilicoSpectraByMasses.js");
const searchMasses_js_1 = require("./searchMasses.js");
class OctoChemDB {
    /**
     *
     * @param {*} options
     */
    constructor(options = {}) {
        this.baseURL = options.baseURL ?? 'https://octochemdb.cheminfo.org/';
    }
    async mfsFromEMs(masses, options = {}) {
        return (0, mfsFromEMs_js_1.mfsFromEMs)(masses, { baseURL: this.baseURL, ...options });
    }
    async compoundsFromMF(mf, options = {}) {
        return (0, compoundsFromMF_js_1.compoundsFromMF)(mf, { baseURL: this.baseURL, ...options });
    }
    async activesOrNaturals(options = {}) {
        return (0, activesOrNaturals_js_1.activesOrNaturals)({ baseURL: this.baseURL, ...options });
    }
    async activesOrNaturalsByMF(options = {}) {
        return (0, activesOrNaturalsByMF_js_1.activesOrNaturalsByMF)({ baseURL: this.baseURL, ...options });
    }
    async activeOrNaturalDetails(id, options = {}) {
        return (0, activeOrNaturalDetails_js_1.activeOrNaturalDetails)(id, { baseURL: this.baseURL, ...options });
    }
    async searchMasses(options = {}) {
        return (0, searchMasses_js_1.searchMasses)({ baseURL: this.baseURL, ...options });
    }
    async massSpectra(options = {}) {
        return (0, massSpectra_js_1.massSpectra)({ baseURL: this.baseURL, ...options });
    }
    async searchInSilicoSpectraByMF(spectrum, mf, options = {}) {
        return (0, searchInSilicoSpectraByMF_js_1.searchInSilicoSpectraByMF)(spectrum, mf, {
            baseURL: this.baseURL,
            ...options,
        });
    }
    async searchInSilicoSpectraByMasses(spectrum, masses, options = {}) {
        return (0, searchInSilicoSpectraByMasses_js_1.searchInSilicoSpectraByMasses)(spectrum, masses, {
            baseURL: this.baseURL,
            ...options,
        });
    }
    async pubmedCompounds(pubmedID, options = {}) {
        return (0, pubmedCompounds_js_1.pubmedCompounds)(pubmedID, { baseURL: this.baseURL, ...options });
    }
}
exports.OctoChemDB = OctoChemDB;
//# sourceMappingURL=OctoChemDB.js.map